<template>
  <login-base-card :loading="loading" class="parent">
        <div v-if="!loading" class="content">
        <p class="content_title">Escolha como deseja receber o link de acesso:</p>
        <div class="content_methods">
          <method-card
            v-for="(method, index) in methods"
            :key="index"
            :text="method.text"
            :type="method.type"
            :code="method.code"
            :icon="method.icon"
            @selectMethod="sendLinkByMethod(method.type)"
          />
        </div>
        <RouterLink
          class="content_footer"
          @click="$emit('backLogin')"
          text="Voltar para o login"
        >
          <template slot="icon">
          <ArrowLeftIcon size="20" />
          </template>
        </RouterLink>
      </div>
      <div v-else class="loader">
        <loading-spinner />
        <span class="gray-500"> {{ loadingText }} </span>
      </div>
  </login-base-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { ArrowLeftIcon } from '@vue-hero-icons/outline';
import MethodCard from '@/feature/login/components/MethodCard.vue';
import LoginBaseCard from '@/feature/login/components/LoginBaseCard.vue';
import RouterLink from '@/components/common/Link.vue';
import { displayTexts } from '../utils/displayTexts';
import LoadingSpinner from '../../paymentLink/components/LoadingSpinner.vue';

export default {
  metaInfo: {
    title: 'Login',
  },
  components: {
    RouterLink,
    MethodCard,
    LoginBaseCard,
    ArrowLeftIcon,
    LoadingSpinner,
  },
  data: () => ({
    displayTexts,
    loading: false,
    loadingMethod: {
      email: 'email',
      sms: 'SMS',
    },
    loadingText: '',
  }),
  computed: {
    ...mapGetters('login', ['getHiddenEmail', 'getEndPhone']),
    methods() {
      return [
        {
          type: 'email',
          text: 'Receber link por email',
          code: this.getHiddenEmail,
          icon: 'mail',
        },
        {
          type: 'sms',
          text: 'Receber link por SMS',
          code: this.getEndPhone,
          icon: 'chat',
        },
      ];
    },
  },
  methods: {
    ...mapActions('login', ['sendLink']),
    async sendLinkByMethod(method) {
      this.loadingText = `Enviando código por ${this.loadingMethod[method]}`;
      this.loading = true;
      await this.sendLink({ method }).then(async () => {
        this.loading = false;
        await this.$router.replace({ name: 'login', params: { method } });
        this.$emit('successToken');
      });
    },
  },
  mounted() {
    if (!this.getHiddenEmail || !this.getEndPhone) this.$emit('backLogin');
  },
};
</script>

<style lang='scss' scoped>

.parent {
  min-height: 26.25rem;
  transition: all 0.3s;

  .content {
    display: flex;
    flex-direction: column;
    animation-name:enter;
    animation-duration:0.3s;

    &_title {
      margin: 0.75rem 0 1.25rem;
      color: #64748B;
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.5rem;
    }

    &_methods {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    &_footer {
      margin-top: 1.25rem;
      align-self: center;
      width: fit-content;

      &:hover {
        color: var(--primary);
        text-decoration: underline;
      }
    }
  }

  &[loading] {
    min-height: 20.75rem;

    @media (max-width: $sm) {
      width: -webkit-fill-available;
      max-width: 28rem;
    }

    .loader {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      animation-name:enter;
      animation-duration:0.3s;
      height: 14.25rem;

      > span {
        @extend .body-regular;
        font-size: 0.875rem;
        margin-top: 0.75rem;
      }
    }
  }
}

  @keyframes enter {
    0% {
      opacity:0;
    }

    100% {
      opacity:1;
    }
  }
</style>
